export default "__VITE_ASSET__Ci7o$WMB__"